import moment from 'moment'

export const DATE_RANGES_COMMON = {
    'Today': [
      moment().startOf('day').toDate(),
      moment().endOf('day').toDate(),
    ],
    'Yesterday': [
      moment().startOf('day').subtract(1, 'day').toDate(),
      moment().endOf('day').subtract(1, 'day').toDate(),
    ],
    'This month': [
      moment().startOf('month').toDate(),
      moment().endOf('month').toDate(),
    ],
    'Last month': [
      moment().startOf('month').subtract(1, 'month').toDate(),
      moment().endOf('month').subtract(1, 'month').toDate(),
    ],
    'This Year': [
      moment().startOf('year').toDate(),
      moment().endOf('year').toDate(),
    ],
    'Last Year': [
      moment().startOf('year').subtract(1, 'year').toDate(),
      moment().endOf('year').subtract(1, 'year').toDate(),
    ],
    'All Time': [
      null,
      null
    ]
  }